var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mw-dialog',{ref:"zgDeptDialog",attrs:{"title":"选择部门机构","size":"mini_mini","footerButton":_vm.btns,"close-on-click-modal":false}},[_c('mw-tree',{ref:"deptTree",staticClass:"mw-dialog-body",attrs:{"url":_vm.deptTreeUrl,"multipleLeaf":false,"async":false,"expandedFirst":true,"multiple":true}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6561c091","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/index/views/appModule/dict/firstDept.vue
// module id = 1225
// module chunks = 0 1